import { sleep } from 'fitbeat.gym-core';
import React, { Component } from 'react';
import { NativeModules, View, StyleSheet } from 'react-native';
import SplashScreen from 'react-native-splash-screen';
import Theme from '../theme';
import { LoadingModal } from '../ui';
import { Storage } from '../utils';
import { connect } from 'react-redux';
import { BaseUserProfile } from 'fitbeat.models';
import auth from '@react-native-firebase/auth';
import { createUserServiceClient } from '../utils/apiClientFactory';
import { Logger } from '../utils/Logger';

const WIFI_CONNECTION_CHECK_TIMEOUT = 2000;
const DELAY_BETWEEN_RETRY_UPDATE_CHECK = 5000;

class EliteLoadingScreen extends Component {
  constructor(props) {
    super(props);
    Logger.debug('[EliteLoadingScreen] ctor');

    this.state = {
      isLoading: true,
    };
  }

  componentDidMount = async () => {
    SplashScreen.hide();
    NativeModules.DeviceSetup.markLaunchCompleted();
    await this.prepareEliteWithRetry();
  }

  prepareEliteWithRetry = async () => {
    try {
      await this.prepareElite();
    } catch (e) {
      // todo: not sure what the safest would be to do here. at least log
      Logger.notify(e);
      setTimeout(async () => {
        Logger.debug('[EliteLoadingScreen] retry prepare');
        await this.prepareEliteWithRetry();
      }, 5000);
    }
  }

  prepareElite = async () => {
    const eliteDeviceIsSetup = await Storage.get('eliteDeviceIsSetup', '');
    if (!eliteDeviceIsSetup) {
      this.navigateTo('Setup', { navigationSource: 'EliteLoadingScreen' });
      await Storage.set('eliteDeviceIsSetup', '1');
      return;
    }

    const isConnectedWithInternet = await this.checkInternetConnection();
    if (!isConnectedWithInternet) {
      this.navigateTo('Wifi', { navigationSource: 'EliteLoadingScreen' });
      return;
    }

    const pending = await this.checkPendingUpdates();
    if (pending) {
      Logger.debug('[EliteLoadingScreen] pending updates', pending);
      this.navigateTo('InstallUpdate');
      return;
    }

    if (auth().currentUser) {
      const userServiceClient = createUserServiceClient();
      const user = await userServiceClient.getAuthenticatedUser();
      if (user && BaseUserProfile.isPartOfFamilyPlan(user)) {
        Logger.debug('[EliteLoadingScreen] logged in with user with isPartOfFamilyPlan');
        this.navigateTo('SelectMember');
        return;
      }
    }

    // when elite checks are done, launch AuthLoadingScreen
    this.navigateTo('AuthLoading');
  }

  checkInternetConnection = async () => {
    try {
      Logger.leaveBreadcrumb('check wifi connection', {
        details: 'checking internet connection from EliteLoadingScreen',
      });
      const connection = await NativeModules.EliteWiFi.waitForInternetConnection(WIFI_CONNECTION_CHECK_TIMEOUT);
      return connection && connection.hasInternet;
    } catch (e) {
      return false;
    }
  }

  checkPendingUpdates = async (retryCount = 0) => {
    try {
      if (this.props.navigation.getParam('skipUpdate')) {
        return null;
      }

      // todo: this should eventually only check for already downloaded files (false)
      // todo: skipIfDeepLink will block updates after logging in with Google auth and switching accounts
      // until screen turned off/on
      Logger.leaveBreadcrumb('check pending updates', {
        details: 'checking for pending updates (over network) from EliteLoadingScreen',
        retryCount,
      });
      return await NativeModules.EliteUpdate.getPendingUpdates(/*checkOnline: */ true, /*skipIfDeepLink: */ true);
    } catch (e) {
      // todo: this is tracked as notifies on native code, but should perhaps change to notify here (#1783)
      Logger.debug('[EliteLoadingScreen] failed to check for updates', { retryCount });
      if (retryCount < 2) {
        if (__DEV__) {
          Logger.debug('[EliteLoadingScreen] debug builds dont retry (simplified/faster debug startup)');
          return undefined;
        }

        await sleep(DELAY_BETWEEN_RETRY_UPDATE_CHECK);
        return await this.checkPendingUpdates(retryCount + 1);
      }
    }
  }

  navigateTo = (route) => {
    this.setState({
      isLoading: false,
    });
    Logger.debug('[EliteLoadingScreen] navigate', route);
    this.props.navigation.navigate(route);
  }

  render() {
    return (
      <View style={styles.container}>
        <LoadingModal isLoading={this.state.isLoading} />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    minHeight: '100%',
    backgroundColor: Theme.WHITE,
  },
});

export default connect()(EliteLoadingScreen);
